import { COLORS, responsive } from "../../../styles/constants.style";
import styled from "styled-components";

export const DeleteMultipleFiltersModalWrapper = styled.div`
  .confirm-message {
    line-height: 20px;
    margin: 24px auto;
    color: ${COLORS.cirrus_black10};
  }

  .item-name {
    line-height: 20px;
    color: ${COLORS.cirrus_black10};
  }

  .filterList .MuiCheckbox-root .MuiSvgIcon-root {
    color: ${COLORS.primary_light_blue};
    border-radius: 2px;
  }

  .delete-multiple-filters-list-container {
    columns: 2 auto;

    ${responsive.MOBILE`
    columns: unset;      
    overflow-y: auto;   
    max-height: 300px; 
  `}
  }
  ${responsive.MOBILE`
  .MuiContainer-root {
    padding-left: 0;
  }
`}
  .MuiList-root {
    padding-top: 0;
  }
  .MuiListItem-root {
    ${responsive.MOBILE`
      padding-left: 0;
    `}
  }
`;
